import {
	AccountEntityType,
	expectedAnnualPaymentsVolumeOptions,
	expectedMonthlyPaymentsCountOptions,
	newAccountsSteps,
	noBusinessWebsiteValue,
} from 'constants/new_accounts.constants';
import { formConfig } from 'sections/pendingRequests/forms.types';
import { getAllDays, getAllMonths, getYears } from 'components/FormCreatorComponent/helpers';
import { incorporationDateGroups } from 'sections/NewAccounts/forms.types';

import {
	customValueTypes,
	fieldMode,
	fieldType,
	fieldsGroupType,
	formThemes,
} from 'components/FormCreatorComponent/types';
import { getFile } from 'services/global.service';
import { countryId } from 'constants/user.constants';
import { ContactLegalStatus } from 'constants/global.constants';
export const overrideNewAccountFormsToApprove: formConfig = {
	[newAccountsSteps.CUSTOMER_DETAILS]: [
		{
			name: 'page.managePendingRequests.forms.customer',
			theme: formThemes.hiddenInputs,
			handleChange: () => {},
			fieldsGroups: [
				{
					type: fieldsGroupType.row,
					fields: [
						{
							type: fieldType.radio,
							mode: fieldMode.readonly,
							props: {
								name: 'entityType',
								label: 'page.accounts.new_account.customer.customer_identification.title',
								options: [
									{ value: 'COMPANY', label: 'customer.type.individual', disabled: false },
									{ value: 'CORPORATION', label: 'customer.type.corporate', disabled: false },
								],
								required: false,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
					],
				},
				{
					type: fieldsGroupType.col,
					fields: [
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'identityNumber',
								label: 'label.identificationNumber.corporate',
								required: false,
								disabled: true,
							},
							validation: [{ requierd: true }],
							dependency: { name: 'entityType', value: AccountEntityType.CORPORATION },
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'identityNumber',
								label: 'label.identificationNumber.company',
								required: false,
								disabled: true,
							},
							validation: [{ requierd: true }],
							dependency: { name: 'entityType', value: AccountEntityType.COMPANY },
						},
					],
				},
				...incorporationDateGroups(fieldMode.readonly),
				{
					type: fieldsGroupType.col,
					fields: [
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'hyperAccountNumber',
								label: 'page.accounts.customer_details.hyper_number',
								required: false,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'accountNameHebrew',
								label: 'page.accounts.customer_details.accountNameHebrew',
								required: false,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'accountNameEnglish',
								label: 'page.accounts.customer_details.accountNameEnglish',
								required: false,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
					],
				},
				{
					type: fieldsGroupType.col,
					title: 'page.accounts.new_account.customer.address_hebrew.title',
					spacing: 0,
					fields: [
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'addressHebrew',
								label: '',
								required: false,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'cityHebrew',
								label: '',
								required: false,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.select,
							mode: fieldMode.readonly,
							props: {
								name: 'countryId',
								label: '',
								options: [],
								required: false,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},

						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'zipCode',
								label: '',
								required: false,
								disabled: true,
							},
							//validation: [{ requierd: true }],
						},
					],
				},
				{
					type: fieldsGroupType.col,
					spacing: 0,
					title: 'page.accounts.new_account.customer.address_english.title',
					fields: [
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'addressEnglish',
								label: '',
								required: false,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'cityEnglish',
								label: '',
								required: false,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.select,
							mode: fieldMode.readonly,
							props: {
								name: 'countryId',
								label: '',
								options: [],
								required: false,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'zipCode',
								label: '',
								required: false,
								disabled: true,
							},
							//validation: [{ requierd: true }],
						},
					],
				},
			],
		},
		{
			name: 'page.managePendingRequests.forms.company',
			theme: formThemes.hiddenInputs,
			handleChange: () => {},
			fieldsGroups: [
				{
					type: fieldsGroupType.col,
					fields: [
						{
							type: fieldType.select,
							mode: fieldMode.readonly,
							ListboxProps: { dir: 'rtl' },
							props: {
								name: 'industryId',
								label: 'page.accounts.new_account.customer.industry',
								options: [],
								required: false,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.select,
							mode: fieldMode.readonly,
							ListboxProps: { dir: 'rtl' },
							props: {
								name: 'businessWebsiteUrl',
								label: 'page.accounts.new_account.customer.business_website',
								options: [
									{
										value: noBusinessWebsiteValue,
										label: 'page.accounts.new_account.customer.no_website',
									},
								],
								required: false,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
					],
				},
				{
					type: fieldsGroupType.col,
					fields: [
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'maxForPayment',
								label: 'label.maxForPayment',
								disabled: true,
							},
							suffix: '$',
							validation: [{ requierd: true }],
							customValueType: customValueTypes.integer,
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'maxForConvert',
								label: 'label.maxForConvert',
								disabled: true,
							},
							suffix: '$',
							validation: [{ requierd: true }],
							customValueType: customValueTypes.integer,
						},
					],
				},
				{
					type: fieldsGroupType.col,
					fields: [
						{
							type: fieldType.select,
							mode: fieldMode.readonly,
							ListboxProps: { dir: 'rtl' },
							props: {
								name: 'expectedAnnualPaymentsVolume',
								label: 'page.accounts.new_account.customer.expected_annual_payments_volume',
								options: expectedAnnualPaymentsVolumeOptions,
								required: false,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.select,
							mode: fieldMode.readonly,
							ListboxProps: { dir: 'rtl' },
							props: {
								name: 'expectedMonthlyPaymentsCount',
								label: 'page.accounts.new_account.customer.expected_monthly_payments_count',
								options: expectedMonthlyPaymentsCountOptions,
								required: false,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'expectedPaymentCountryIds',
								label: 'page.accounts.new_account.customer.expected_payment_countries',
								required: false,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.select,
							mode: fieldMode.readonly,
							ListboxProps: { dir: 'rtl' },
							props: {
								name: 'expectedPaymentCurrencyId',
								label: 'page.accounts.new_account.customer.expected_payment_currency',
								options: [],
								required: false,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
					],
				},
				{
					type: fieldsGroupType.row,
					fields: [
						{
							type: fieldType.select,
							mode: fieldMode.readonly,
							ListboxProps: { dir: 'rtl' },
							props: {
								name: 'riskLevel',
								label: 'page.accounts.new_account.customer.client_risk_level',
								options: [
									{ value: 'low', label: 'נמוך' },
									{ value: 'medium', label: 'בינוני' },
									{ value: 'high', label: 'גבוהה' },
									{ value: 'veryHigh', label: 'גבוהה מאוד' },
								],
								required: false,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
					],
				},
			],
		},
		{
			name: 'page.managePendingRequests.forms.management',
			theme: formThemes.hiddenInputs,
			handleChange: () => {},
			fieldsGroups: [
				{
					type: fieldsGroupType.col,
					fields: [
						{
							type: fieldType.select,
							mode: fieldMode.write,
							ListboxProps: { dir: 'rtl' },
							props: {
								name: 'customerSuccessManagerId',
								label: 'page.customerAccounts.basicData.manager',
								options: [],
								required: false,
								disabled: false,
							},
						},
						{
							type: fieldType.select,
							mode: fieldMode.write,
							ListboxProps: { dir: 'rtl' },
							props: {
								name: 'agentId',
								label: 'page.customerAccounts.basicData.agent',
								options: [],
								required: false,
								disabled: false,
							},
						},
						{
							type: fieldType.select,
							mode: fieldMode.write,
							ListboxProps: { dir: 'rtl' },
							props: {
								name: 'dealerId',
								label: 'page.customerAccounts.basicData.dealer',
								options: [],
								required: false,
								disabled: false,
							},
						},
						{
							type: fieldType.select,
							mode: fieldMode.write,
							ListboxProps: { dir: 'rtl' },
							props: {
								name: 'leadId',
								label: 'page.customerAccounts.basicData.lead',
								options: [],
								required: false,
								disabled: false,
							},
						},
					],
				},
			],
		},
	],
	[newAccountsSteps.USER_DETAILS]: [
		{
			name: 'page.managePendingRequests.forms.account',
			theme: formThemes.hiddenInputs,
			handleChange: () => {},
			fieldsGroups: [
				{
					type: fieldsGroupType.col,
					fields: [
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'firstNameHebrew',
								label: 'label.firstName',
								required: false,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'lastNameHebrew',
								label: 'label.lastName',
								required: false,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'firstNameEnglish',
								label: 'label.firstNameEnglish',
								required: false,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'lastNameEnglish',
								label: 'label.lastNameEnglish',
								required: false,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
					],
				},
				{
					type: fieldsGroupType.row,
					title: 'label.birthDate',
					fields: [
						{
							type: fieldType.select,
							mode: fieldMode.readonly,
							props: {
								name: 'day',
								label: 'label.day',
								options: getAllDays(),
								required: false,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.select,
							mode: fieldMode.readonly,
							props: {
								name: 'month',
								label: 'label.month',
								options: getAllMonths(),
								required: false,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.select,
							mode: fieldMode.readonly,
							props: {
								name: 'year',
								label: 'label.year',
								options: getYears(),
								required: false,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
					],
				},
				{
					type: fieldsGroupType.row,
					fields: [
						{
							type: fieldType.radio,
							mode: fieldMode.readonly,
							props: {
								name: 'legalStatus',
								label: 'label.publicFigure',
								options: [
									{ value: 'Legal', label: 'label.yes', disabled: true },
									{ value: 'NotLegal', label: 'label.no', disabled: true },
								],
								required: false,
								disabled: true,
							},
							validation: [{ requierd: true }],
							customValue: (value) => (value === ContactLegalStatus.Legal ? 'כן' : 'לא'),
						},
					],
				},
				{
					type: fieldsGroupType.row,
					fields: [
						{
							type: fieldType.radio,
							mode: fieldMode.readonly,
							props: {
								name: 'identificationType',
								label: 'label.identificationType',
								options: [
									{ value: 'ID', label: 'label.identicationId', disabled: true },
									{ value: 'Passport', label: 'label.passport', disabled: true },
								],
								required: false,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
					],
				},
				/*
				{
					type: fieldsGroupType.col,
					fields: [
						{
							type: fieldType.radio,
							mode: fieldMode.readonly,
							props: {
								name: 'gender',
								label: 'label.gender',
								options: [
									{ value: 'Male', label: 'label.male', disabled: true },
									{ value: 'Female', label: 'label.female', disabled: true },
								],
								required: false,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
					],
				},
				*/
				{
					type: fieldsGroupType.row,
					fields: [
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'identificationNumber',
								label: 'page.accounts.new_account.customer.customer_identification.title',
								required: false,
								disabled: false,
							},
							validation: [{ requierd: true }],
						},
					],
				},
			],
		},
		{
			name: 'page.managePendingRequests.forms.contact',
			theme: formThemes.hiddenInputs,
			handleChange: () => {},
			fieldsGroups: [
				{
					type: fieldsGroupType.col,
					fields: [
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'emailAddress',
								label: 'label.email',
								required: false,
								disabled: true,
							},
							validation: [{ requierd: true }, { email: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'phoneNumber',
								label: 'label.phone',
								required: false,
								disabled: true,
							},
							validation: [{ requierd: true }, { phone: true }],
						},
						/*
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'address',
								label: 'label.address',
								required: false,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'city',
								label: 'label.city',
								required: false,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.select,
							mode: fieldMode.readonly,
							props: {
								name: 'countryId',
								label: 'label.country',
								required: true,
								disabled: false,
								options: [{ value: countryId, label: 'Israel' }],
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.select,
							mode: fieldMode.readonly,
							props: {
								name: 'birthCountryId',
								label: 'label.birthCountryId',
								required: true,
								disabled: false,
							},
							validation: [{ requierd: true }],
						},
						*/
					],
				},
			],
		},
		{
			name: 'page.managePendingRequests.forms.manageAccountDetails',
			theme: formThemes.hiddenInputs,

			handleChange: () => {},
			fieldsGroups: [
				{
					type: fieldsGroupType.col,
					fields: [
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'role',
								label: 'label.role',
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.select,
							mode: fieldMode.readonly,
							props: {
								name: 'permission',
								label: 'label.permisionLevel',
								options: [
									{ label: 'label.Signer', value: 'Signer' },
									{ label: 'label.Operationer', value: 'Operationer' },
									{ label: 'label.Viewer', value: 'Viewer' },
								],
								required: false,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'maxForPayment',
								label: 'label.maxForPayment',
								disabled: true,
							},
							suffix: '$',
							validation: [{ requierd: true }],
							customValueType: customValueTypes.integer,
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'maxForConvert',
								label: 'label.maxForConvert',
								disabled: true,
							},
							suffix: '$',
							validation: [{ requierd: true }],
							customValueType: customValueTypes.integer,
						},
					],
				},
			],
		},
	],
	[newAccountsSteps.BANK_ACCOUNT_DETAILS]: [
		{
			name: 'page.managePendingRequests.forms.bank',
			theme: formThemes.hiddenInputs,
			handleChange: () => {},
			fieldsGroups: [
				{
					type: fieldsGroupType.col,
					fields: [
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'accountOwnerName',
								label: 'page.pendingRequests.field.accountOwnerName',
								required: false,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.select,
							mode: fieldMode.readonly,
							props: {
								name: 'bankId',
								label: 'page.pendingRequests.field.bankName',
								options: [],
								required: false,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'bankBranch',
								label: 'page.pendingRequests.field.bankBranch',
								required: false,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
						{
							type: fieldType.text,
							mode: fieldMode.readonly,
							props: {
								name: 'accountNumber',
								label: 'page.pendingRequests.field.accountNumber',
								required: false,
								disabled: true,
							},
							validation: [{ requierd: true }],
						},
					],
				},
			],
		},
		{
			name: 'page.managePendingRequests.forms.approveAccount',
			theme: formThemes.hiddenInputs,

			handleChange: () => {},
			fieldsGroups: [
				{
					type: fieldsGroupType.col,
					fields: [
						{
							type: fieldType.file,
							mode: fieldMode.readonly,
							props: {
								name: 'file',
								label: 'page.pendingRequests.field.fileReference',
								required: true,
								disabled: true,
								onClick: (file) => {
									getFile(file?.key);
								},
							},
							validation: [{ requierd: true }],
						},
					],
				},
			],
		},
	],
};
